<section class="w-10/12 sm:w-9/12 mx-auto">
  <hr />
  <div class="company py-16">
    @for (company of companies; track company; let i = $index) {
      <img
        class="sm:justify-self-auto"
        [attr.src]="`assets/img/MainPage/Companies/${company}.svg`"
        [attr.alt]="company"
        [class.justify-self-start]="i % 3 === 0"
        [class.justify-self-center]="(i + 1) % 3 === 0"
        [class.justify-self-end]="(i + 2) % 3 === 0"
      />
    }
  </div>
</section>
